var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHospitalSideMenuIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 20,
  fill: "none",
  viewBox: "0 0 16 20",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#49475A",
  d: "M7.2 0v1.6H5.6v1.6h1.6v1.6h1.6V3.2h1.6V1.6H8.8V0zM0 1.6V20h7.2v-2.4h1.6V20H16V1.6h-4v1.6h2.4v15.2h-4V16H5.6v2.4h-4V3.2H4V1.6zm4 4.8V8h1.6V6.4zm3.2 0V8h1.6V6.4zm3.2 0V8H12V6.4zM4 9.6v1.6h1.6V9.6zm3.2 0v1.6h1.6V9.6zm3.2 0v1.6H12V9.6zM4 12.8v1.6h1.6v-1.6zm3.2 0v1.6h1.6v-1.6zm3.2 0v1.6H12v-1.6z"
})));
export { SvgHospitalSideMenuIcon as ReactComponent };
export default __webpack_public_path__ + "assets/images/hospital-side-menu-icon.svg";